import axios from 'axios'

import { environment } from '@/shared/consts/environment'
import './axiosAuthMiddleware'
import { errorMiddleware } from './errorMiddleware'
import { IRecommendation } from '@/interfaces/recommendation'

const apiUrl = `${environment.apiUrl}/api/v1/search`

interface SearchParams {
  searchTerm: string
  skipCount: number
  pageSize: number
}

const CACHE_DURATION = 30000
const SearchCache: Record<
  string,
  { timestamp: number; results: IRecommendation[] }
> = {}

export const search = async (
  params: SearchParams,
  controller?: AbortController
) => {
  const { searchTerm, skipCount, pageSize } = params
  const cacheValue = getSearchResultsFromCache({
    searchTerm,
    skipCount,
    pageSize,
  })
  if (cacheValue) return cacheValue
  try {
    const res = await axios.post<null, { data: IRecommendation[] }>(
      `${apiUrl}/`,
      {
        searchTerm,
        skipCount,
        pageSize,
      },
      {
        signal: controller?.signal,
      }
    )
    updateSearchCache(res.data, { searchTerm, skipCount, pageSize })
    return res.data
  } catch (error) {
    return errorMiddleware(error)
  }
}

const getSearchResultsFromCache = (params: SearchParams) => {
  const cacheKey = getCacheKey(params)
  const cacheValue = SearchCache[cacheKey]
  if (cacheValue && Date.now() - cacheValue.timestamp <= CACHE_DURATION) {
    return cacheValue.results
  }
  return null
}

const updateSearchCache = (
  results: IRecommendation[],
  params: SearchParams
) => {
  const cacheKey = getCacheKey(params)
  SearchCache[cacheKey] = {
    results,
    timestamp: Date.now(),
  }
}

const getCacheKey = (params: SearchParams) => {
  const { searchTerm, skipCount, pageSize } = params
  return JSON.stringify({ searchTerm, skipCount, pageSize })
}
